const fonts = [
  {
    name: 'Alegreya',
    fontFamily: "'Alegreya', serif",
    url: 'https://fonts.googleapis.com/css2?family=Alegreya:wght@400;500;700&display=swap',
  },
  {
    name: 'Archivo',
    fontFamily: "'Archivo', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600;700&display=swap',
  },
  {
    name: 'B612',
    fontFamily: "'B612', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=B612:wght@400;700&display=swap',
  },
  {
    name: 'Bebas Neue',
    fontFamily: "'Bebas Neue', cursive",
    url: 'https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap',
  },
  {
    name: 'BioRhyme',
    fontFamily: "'BioRhyme', serif",
    url: 'https://fonts.googleapis.com/css2?family=BioRhyme:wght@200;300;400;700&display=swap',
  },
  {
    name: 'Cardo',
    fontFamily: "'Cardo', serif",
    url: 'https://fonts.googleapis.com/css2?family=Cardo:wght@400;700&display=swap',
  },
  {
    name: 'Cairo',
    fontFamily: "'Cairo', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Cairo:wght@200;300;400;600;700&display=swap',
  },
  {
    name: 'Crimson Text',
    fontFamily: "'Crimson Text', serif",
    url: 'https://fonts.googleapis.com/css2?family=Crimson+Text:wght@400;600;700&display=swap',
  },
  {
    name: 'Frank Ruhl Libre',
    fontFamily: "'Frank Ruhl Libre', serif",
    url: 'https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre:wght@300;400;500;700&display=swap',
  },
  {
    name: 'IBM Plex',
    fontFamily: "'IBM Plex Sans', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@100;200;300;400;500;600;700&display=swap',
  },
  {
    name: 'Karla',
    fontFamily: "'Karla', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Karla:wght@200;300;400;500;600;700&display=swap',
  },
  {
    name: 'Lato',
    fontFamily: "'Lato', Tahoma, Verdana, sans-serif",
    url: 'https://fonts.googleapis.com/css?family=Lato',
  },
  {
    name: 'Lora',
    fontFamily: "'Lora', serif",
    url: 'https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600;700&display=swap',
  },
  {
    name: 'Montserrat',
    url: 'https://fonts.googleapis.com/css?family=Montserrat',
    fontFamily: "'Montserrat', Trebuchet MS, Lucida Grande, Lucida Sans Unicode, sans-serif",
  },
  {
    name: 'Mulish',
    fontFamily: "'Mulish', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700&display=swap',
  },
  {
    name: 'Playfair Display',
    fontFamily: "'Playfair Display', serif",
    url: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap',
  },
  {
    name: 'Poppins',
    fontFamily: "'Poppins', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700&display=swap',
  },
  {
    name: 'Rubik',
    fontFamily: "'Rubik', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap',
  },
  {
    name: 'Roboto',
    fontFamily: "'Roboto', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500&display=swap',
  },
  {
    name: 'Source Sans',
    fontFamily: "'Source Sans Pro', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&display=swap',
  },
  {
    name: 'Titillium Web',
    fontFamily: "'Titillium Web', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Titillium+Web:wght@200;300;400;600;700&display=swap',
  },
  {
    name: 'Varela',
    fontFamily: "'Varela', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Varela&display=swap',
  },
  {
    name: 'Vollkorn',
    fontFamily: "'Vollkorn', serif",
    url: 'https://fonts.googleapis.com/css2?family=Vollkorn:wght@400;500;600;700&display=swap',
  },
  {
    name: 'Red Hat Text',
    fontFamily: "'Red Hat Text', sans-serif",
    url: 'https://fonts.googleapis.com/css2?family=Red+Hat+Text:wght@400;500;700&display=swap',
  },
];

export default fonts;
